module.exports = __webpack_public_path__ + "static/img/coins.0a3cd911.png";